// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'

// import 'element-ui/lib/theme-chalk/index.css'
import './theme/index.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import VueVideoPlayer from 'vue-video-player'
// require videojs style
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer /* {
  options: global default options,
  events: global videojs events
} */)
Vue.use(ElementUI, { locale })
Vue.prototype.$axios = Axios

Vue.prototype.$axios.defaults.baseURL = 'http://www.angerdream21.top/v/tp6/public/index.php'
// Vue.prototype.$axios.defaults.baseURL = 'http://192.168.188.151/tp6/public/index.php'
// Vue.prototype.$axios.defaults.baseURL = 'http://127.0.0.1/tp6/public/index.php'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js